import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class RolesApi {
  static getPermissionSchema = () => {
    return axios.get(`${API_BASE_URL}/permissions`);
  };

  static getFacilityPermissionSchema = () => {
    return axios.get(`${API_BASE_URL}/permissions/facility`);
  };

  static getOrganizationPermissionSchema = () => {
    return axios.get(`${API_BASE_URL}/permissions/organization`);
  };

  static getRoles = (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return axios.get(`${API_BASE_URL}/roles?${queryParams}`);
  };

  static getRole = (roleId) => {
    return axios.get(`${API_BASE_URL}/roles/${roleId}`);
  };

  static createRole = (roleData) => {
    return axios.post(`${API_BASE_URL}/roles`, roleData);
  };

  static updateRole = (roleId, roleData) => {
    return axios.put(`${API_BASE_URL}/roles/${roleId}`, roleData);
  };

  static deleteRole = (roleId) => {
    return axios.delete(`${API_BASE_URL}/roles/${roleId}`);
  };

  static getRoleAuditTrail = (roleId, params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return axios.get(
      `${API_BASE_URL}/roles/${roleId}/audit-trail?${queryParams}`,
    );
  };

  static getRoleHistory = (roleId, params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return axios.get(`${API_BASE_URL}/roles/${roleId}/history?${queryParams}`);
  };

  static getRolesForForms = (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.organization_id) {
      queryParams.append('organization_id', params.organization_id);
    }

    const queryString = queryParams.toString();
    return axios.get(
      `${API_BASE_URL}/roles/for-forms${queryString ? `?${queryString}` : ''}`,
    );
  };
}
